<template>
  <div>
    <!--Wrapper Start-->
    <div class="wrapper">
      <div class="main-content">
        <b-skeleton v-if="loading" height="500px" class="w-100"></b-skeleton>
        <slider @noSlides="noSlides = true" v-else class="" />
        <!--Mayor Msg with Video Start-->
        <section class="Mayor-video-msg">
          <div class="container">
            <div class="row align-items-top" :class="noSlides ? 'mt-3' : ''">
              <div class="col-md-2 col-sm-5">
                <!--Mayor Msg Start-->

                <div
                  style="z-index: 2"
                  class="city-tour bg-white p-1 image_ngo"
                  :class="{ 'no-float': noSlides }"
                >
                  <img
                    v-if="ngoData.ngo && ngoData.ngo.logo"
                    height="180px"
                    class="bg-white"
                    alt="ngo logo"
                    :src="ngoData.ngo.logo || ''"
                    style="position: relative; z-index: 2"
                    controls
                  />
                  <!-- require('@/assets/images/test-logo.png') -->
                </div>

                <!--Mayor Msg End-->
              </div>
              <div class="col-md-10 col-sm-7">
                <div v-if="loading">
                  <b-skeleton animation="fade" width="20%"></b-skeleton>
                  <b-skeleton
                    v-for="n in 4"
                    :key="n"
                    animation="fade"
                    width="85%"
                  ></b-skeleton>
                </div>
                <div class="Mayor-welcome" v-else>
                  <h5>{{ ngoData.ngo.name_ar }}</h5>
                  <div class="text-light mb-1">
                    <span class="alert text-dark alert-light px-25"
                      >{{ logo.legalForm ? logo.legalForm.name_ar : "" }}
                    </span>
                    &nbsp; -
                    <span class="text-light">
                      رقم قرار الإشهار : {{ ngoData.ngo.decision_no }}
                    </span>
                  </div>

                  <p
                    class="text-align-justify mb-0"
                    v-html="ngoData.ngo.about"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!--Mayor Msg with Video End-->
        <!--City News Start-->
        <section class="wf100 p80 community-links">
          <div class="container">
            <div class="title-style-3">
              <h3>خدمات المنظمة</h3>
            </div>
            <div
              v-if="loadingsetPrograms"
              class="d-flex w-100 justify-content-between"
            >
              <b-skeleton v-for="n in 4" :key="n" height="250px" width="300px">
              </b-skeleton>
            </div>
            <div v-else class="row">
              <!--Department Box Start-->
              <div
                v-for="item in programs"
                :key="item.id"
                class="col-md-3 col-sm-6 my-2"
              >
                <div class="community-box mb-1 program_servies">
                  <h6 style="font-size: 16px; line-height: 30px" class="p-1">
                    {{ item.service ? item.service.name_ar : "" }}
                  </h6>
                  <vue-perfect-scrollbar
                    style="max-height: 190px"
                    class="search-list search-list-bookmark scroll-area"
                    :settings="perfectScrollbarSettings"
                  >
                    <P class="my-1 px-1 text-align-justify">
                      {{ item.description }}
                    </P>
                  </vue-perfect-scrollbar>
                </div>
              </div>
              <!--Department Box End-->
            </div>
            <alert
              v-if="programs.length == 0 && !loadingsetPrograms"
              class="w-100"
              :massage="$t('alert')"
            >
            </alert>
          </div>
        </section>
        <section class="wf100 some-facts p75-50">
          <div class="container">
            <div class="title-style-3">
              <h3 class="text-white">إحصائيات المنظمة</h3>
            </div>
            <div
              class="d-flex justify-content-center"
              v-if="!loadingStatistics"
            >
              <swiper
                class="swiper-responsive-breakpoints w-100 mx-2"
                :options="swiperOptionsStatistics"
              >
                <swiper-slide
                  v-for="item in statistics"
                  :key="item.id"
                  class="rounded-lg cat-wrapper pt-1 pb-1"
                >
                  <div>
                    <div class="facts-icon">
                      <feather-icon size="35" :icon="item.icon"></feather-icon>
                    </div>
                    <div class="count_number text-center">
                      {{ item.count.toLocaleString("en-US") }}
                    </div>
                    <div class="text-center title_statistics">
                      {{ item.title }}
                    </div>
                  </div>
                </swiper-slide>
                <div slot="button-next" class="swiper-button-next text-white" />
                <div slot="button-prev" class="swiper-button-prev text-white" />
              </swiper>
            </div>
            <div v-if="!loadingStatistics">
              <alert
                v-if="statistics.length == 0 && !loadingStatistics"
                class="w-100"
                :massage="$t('alert')"
              >
              </alert>
            </div>
          </div>
        </section>
        <section class="wf100 p75-50 depart-info">
          <div class="container">
            <div class="">
              <div class="title-style-3">
                <h3>منظمات مشابهة</h3>
              </div>
              <div v-if="loading" class="mt-3 d-flex justify-content-center">
                <swiper
                  class="swiper-responsive-breakpoints"
                  :options="swiperOptions"
                  :dir="$store.state.appConfig.isRTL ? 'ltr' : 'rtl'"
                >
                  <swiper-slide
                    v-for="n in 5"
                    :key="n"
                    class="rounded-lg cat-wrapper pt-1 pb-1"
                  >
                    <b-skeleton height="225px" width="250px" class="m-1">
                    </b-skeleton>
                  </swiper-slide>
                </swiper>
              </div>
              <div v-else>
                <swiper
                  class="swiper-responsive-breakpoints d-flex mt-3 mx-2 justify-content-center"
                  :options="swiperOptions"
                  :dir="$store.state.appConfig.isRTL ? 'ltr' : 'rtl'"
                >
                  <swiper-slide
                    v-for="item in ngoData.similar"
                    :key="item.id"
                    class="rounded-lg cat-wrapper pt-1 pb-1"
                  >
                    <ngo-card
                      :id="item.id"
                      :logo="item.logo"
                      :name_ngo="item.name_ar"
                    ></ngo-card>
                    <!-- <div class="deprt-icon-box">
                      <img class="img_list_min" :src="item.logo" alt="" />
                      <h6 class="name_list_min">{{ item.name_ar }}</h6>
                      <router-link
                        :to="{ name: 'ngo-home', params: { id: item.id } }"
                        class="rm"
                      >
                      <div>
                        عرض معلومات المنظمة
                      </div>
                      </router-link>
                    </div> -->
                  </swiper-slide>
                </swiper>
              </div>
              <div v-if="!loading">
                <alert
                  v-if="ngoData.similar.length == 0 && !loading"
                  class="w-100"
                  :massage="$t('alert')"
                >
                </alert>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!--Wrapper End-->

    <nav id="sidebar">
      <div id="dismiss"><i class="fas fa-arrow-right"></i></div>
      <div class="sidebar-header">
        <img src="images/footer-logo2.png" alt="" />
      </div>
      <ul class="list-unstyled components">
        <li class="active">
          <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false"
            >Home</a
          >
          <ul class="collapse list-unstyled" id="homeSubmenu">
            <li><a href="index-2.html">Default Home Page</a></li>
            <li><a href="home-two.html">Home Page Two</a></li>
            <li><a href="home-three.html">Home Page Three</a></li>
          </ul>
        </li>
        <li><a href="aboutus.html">About Us</a></li>
        <li><a href="departments.html">Departments</a></li>
        <li><a href="news-full.html">News</a></li>
        <li><a href="event.html">Events</a></li>
        <li><a href="explore-city.html">Explore City</a></li>
        <li><a href="services.html">Services</a></li>
        <li><a href="contact.html">Contact</a></li>
      </ul>
    </nav>
    <div class="overlay"></div>
  </div>
</template>

<script>
import NgoHeader from "../../components/NgoHeader";
import SkeletonText from "../../components/SkeletonText.vue";
import Slider from "../../components/Slider";
import { AlertCircleIcon } from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import {
  BNav,
  BNavItem,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BPagination,
  BAlert,
  BSpinner,
  BSkeleton,
} from "bootstrap-vue";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Alert from "@/components/Alert";
import { mapGetters } from "vuex";
import NgoCard from "../../components/NgoCard.vue";

export default {
  components: {
    Slider,
    NgoHeader,
    BNav,
    BNavItem,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BPagination,
    SkeletonText,
    BAlert,
    AlertCircleIcon,
    BSpinner,
    Swiper,
    SwiperSlide,
    Alert,
    BSkeleton,
    NgoCard,
    VuePerfectScrollbar,
  },
  data() {
    return {
      noSlides: false,
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          300: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
        },
      },
      swiperOptionsStatistics: {
        slidesPerView: 5,
        spaceBetween: 50,
        pagination: {
          el: ".statistics-swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
        },
      },
      swiperOptionsServes: {
        centeredSlides: true,
        spaceBetween: 10,
        direction: "vertical",
      },
    };
  },

  computed: {
    ...mapGetters("NgoHome/ngos", [
      "ngoData",
      "loading",
      "loadingsetPrograms",
      "programs",
      "statistics",
      "loadingStatistics",
    ]),
    ...mapGetters("NgoHome", ["logo"]),
  },
  created() {
    this.$store.dispatch(`NgoHome/ngos/getNgoData`, {
      id: this.$route.params.id,
    });
    this.$store.dispatch(`NgoHome/ngos/getPrograms`, {
      id: this.$route.params.id,
    });
    this.$store.dispatch(`NgoHome/ngos/getStatistics`, {
      id: this.$route.params.id,
    });
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 100,
    };
    return {
      // UI
      perfectScrollbarSettings,
    };
  },
};
</script>

<style lang="scss">
.no-float {
  margin: 0px !important;
}

.image_ngo {
  display: flex;
}

@media (max-width: 530px) {
  .image_ngo {
    display: none;
  }
}

.h3-logo-row .h3-logo {
  padding: 2px !important;
}

.title_statistics {
  font-size: x-large;
  color: #fff;
}

.count_number {
  font-size: 30px;
  color: #fff;

  &:hover {
    color: #ffcb0b;
  }
}

.program_servies {
  height: 300px;
}
</style>
